/**
 * The one rule for which namespace the "Create definitions" run uses
 * (BLU-1399, architect N12). `CreateDefinitionsBlock` seeds its namespace from
 * the first valid mapping namespace, else it keeps `fixedNamespace` (the
 * onboarding wizard's `printrun`) or this default. The onboarding step reads
 * the same rule to decide whether the run will create the preview fields, so
 * the row it shows never promises a field the run will not create.
 *
 * A `.ts` module so the react-refresh lint rule stays quiet.
 */

/** Same regex as the DB CHECK constraint, the router's Zod schema, and ProductDataLookupCard's NS_KEY_REGEX. */
export const NS_KEY_REGEX = /^[a-z][a-z0-9_]{0,63}$/;

/** The block's namespace when there is no mapping and no fixed namespace (Settings). */
export const DEFAULT_DEFINITIONS_NAMESPACE = 'custom';

/** The first mapping's namespace when it is a valid namespace, else null. */
export function firstMappingNamespace(mappings: ReadonlyArray<{ namespace: string }> | undefined | null): string | null {
  const seed = mappings?.[0]?.namespace;
  return seed && NS_KEY_REGEX.test(seed) ? seed : null;
}
